<template>
    <v-col cols="12" md="6" sm="12" xs="12">
        <v-select
            v-model="form.copier.owns_mailing_machine"
            label="Do you currently own a mailing machine?"
            density="compact"
            variant="outlined"
            :items="[{title:'---',value:null},'Yes','No']">
        </v-select>
    </v-col>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { form } = storeToRefs(store)
</script>
